import ReportAbuse from './ReportAbuse';

export default ReportAbuse;
